import { useState } from 'react';
import { PackageOpen, Check } from 'lucide-react';
import { supabase } from '../supabaseClient';

// What every non-staff visitor sees while the store is paused. One message and
// one box: leave an email and we send a single "we're back" note when staff
// reopen. Signups are tied to this pause (sv_restock_signup), so only people
// who asked during it are emailed.
export default function StorePausedPage() {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | sending | done | error

  const submit = async (e) => {
    e.preventDefault();
    if (state === 'sending') return;
    setState('sending');
    try {
      const { data, error } = await supabase.rpc('sv_restock_signup', { p_email: email.trim() });
      setState(!error && data ? 'done' : 'error');
    } catch {
      setState('error');
    }
  };

  return (
    <div className="sv-container sv-page-top sv-page-bottom" style={{ maxWidth: 560, textAlign: 'center', paddingTop: 110 }}>
      <span
        style={{
          width: 64, height: 64, borderRadius: 999, margin: '0 auto 22px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'color-mix(in srgb, var(--accent) 14%, transparent)', color: 'var(--accent)',
        }}
      >
        <PackageOpen size={30} />
      </span>
      <h1 style={{ fontSize: '1.9rem', fontWeight: 900, letterSpacing: '-0.02em', marginBottom: 12 }}>
        We&rsquo;re updating our inventory
      </h1>
      <p style={{ color: 'var(--text-muted)', fontSize: '1.05rem', lineHeight: 1.6, marginBottom: 30 }}>
        Looking forward to surpassing your expectations!
      </p>

      <div className="sv-card" style={{ padding: 22, textAlign: 'left' }}>
        {state === 'done' ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span
              style={{
                width: 34, height: 34, borderRadius: 999, flexShrink: 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: 'color-mix(in srgb, var(--success, #1f9d55) 16%, transparent)', color: 'var(--success, #1f9d55)',
              }}
            >
              <Check size={18} />
            </span>
            <div style={{ fontSize: '0.95rem', lineHeight: 1.5 }}>
              <strong>You&rsquo;re on the list.</strong> We&rsquo;ll send you one email the moment the vault reopens.
            </div>
          </div>
        ) : (
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <label htmlFor="restock-email" style={{ fontWeight: 700, fontSize: '0.95rem' }}>
              Email me when we&rsquo;re back
            </label>
            <input
              id="restock-email"
              className="sv-input"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => { setEmail(e.target.value); if (state === 'error') setState('idle'); }}
              required
              autoComplete="email"
            />
            {state === 'error' && (
              <div style={{ color: 'var(--danger)', fontSize: '0.82rem' }}>
                That email didn&rsquo;t go through. Check it and try again.
              </div>
            )}
            <button type="submit" className="sv-btn" disabled={state === 'sending'} style={{ justifyContent: 'center' }}>
              {state === 'sending' ? 'Saving…' : 'Notify me'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
